import Breakpoints from "./Breakpoints.js";
class Menu {
  constructor() {
    if(document.querySelectorAll('[data-menu-button]').length > 0) {
      this.DOM = {
        button: document.querySelector('[data-menu-button]'),
        container: document.querySelector('[data-menu-container'),
      };
      this.text = {
        open: this.DOM.button.getAttribute('aria-label'),
        close: this.DOM.button.dataset.textClose,
      };
      this.scrollTop = 0;
      this.breakpoints = new Breakpoints();
      this.isDesktop = this.breakpoints.up('md');
      this.#addEvent();
      this.#init();
    }
  }
  #init() {
    if (this.isDesktop.matches) {
      this.#open()
    } else {
      this.#close();
    }
  }
  #addEvent() {
    this.isDesktop.addEventListener('change', () => {
      if (this.isDesktop.matches) {
        this.#open();
      } else {
        this.#close();
      }
    });
    this.DOM.button.addEventListener('click', this.#toggle.bind(this));
  }
  #toggle() {
    if (this.DOM.button.getAttribute('aria-expanded') === 'false') {
      this.#open();
      // this.#notScrollable();
    } else {
      this.#close();
      // this.#scrollable();
    }
  }
  #open() {
    this.DOM.button.setAttribute('aria-label', this.text.close);
    this.DOM.button.setAttribute('aria-expanded', 'true');
    this.DOM.container.setAttribute('aria-hidden', 'false');
  }
  #close() {
    this.DOM.button.setAttribute('aria-label', this.text.open);
    this.DOM.button.setAttribute('aria-expanded', 'false');
    this.DOM.container.setAttribute('aria-hidden', 'true');
  }
  // #notScrollable() {
  //   this.scrollTop = window.scrollY;
  //   document.body.style.top = (this.scrollTop * -1) + 'px';
  //   document.body.classList.add('no_scroll');
  // }
  // #scrollable() {
  //   document.body.classList.remove('no_scroll');
  //   document.body.style.top = '';
  //   window.scrollTo(0, this.scrollTop);
  // }
}
export default Menu;